import React, { useState, useEffect, useRef } from 'react';
import { Icon, Button, Spin, Checkbox } from 'antd';
import { EaseDrawer } from '../../../libs/EaseDrawer';
import { TransferWizard, BeneficiaryModal, OTPModal } from '../../Common';
import { ContactInfo } from './contact_info';
import { BeneficiariesInfo } from './beneficiaries_info';
import { Beneficiary } from '../../../models';
import { alertify, handleApiExceptions, generate_query_set } from '../../../app_methods';
import { FullWidthDivider, Text5 } from '../../../styles';
import './index.scss';
import { PermissionHoc } from '../../HOC';
import { MerchantService } from '../../../services';
import { goTo } from '../../../app_methods';

const PermissableButton = PermissionHoc(Button, "BENEFICIARIES_WRITE", { is_component: true, fallbackComponent: null });

const BeneficiariesDrawer = (props) => {
    const [isListLoading, setIsListLoading] = useState(false);
    const [beneficiaries, setBeneficiaries] = useState([]);
    const [beneficiary, setBeneficiary] = useState({});
    const [beneficiaryModal, setBeneficiaryModal] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [activeBeneficiary, setActiveBeneficiary] = useState({});
    const [transferRequestWizard, setTransferRequestWizard] = useState(false);
    const [showOTPModal, setShowOTPModal] = useState(false)
    const [OTPReferenceDetails, setOTPReferenceDetails] = useState()
    const [isBankOTP, setIsBankOTP] = useState(false);
    const [saveBeneDetails, setSaveBeneDetails] = useState("");
    const saveBeneDetailsRef = useRef("");
    const [isRenderOTPModal, setIsRenderOTPModal] = useState(false);
    const [beneOnBankLoaderId, setBeneOnBankLoaderId] = useState(null);

    const fetchBeneficiaries = async (showDeactivated = false) => {
        setIsListLoading(true);
        // let filterargs = { contact_id: props.contact.uuid, pageSize: 100, is_submerchant: props.contact.is_submerchant };
        let filterargs = { contact_id: props.contact.uuid, pageSize: 100 };
        filterargs = showDeactivated ? filterargs : { ...filterargs, is_active: true };
        const response = await Beneficiary.list_v2(filterargs);
        if (!response.success) {
            setIsListLoading(false);
            handleApiExceptions(response);
            return;
        }
        setBeneficiaries(response.data.results);
        setIsListLoading(false);
    };

    const saveBeneficiary = async (values) => {
        setIsSaving(true);
        const beneficiary = new Beneficiary(values);
        let response
        let message = "Beneficiary created successfully."
        if (values?.id) {
            response = await beneficiary.update();
            message = "Beneficiary updated successfully.";
        } else {
            response = await beneficiary.save();
            message = "Beneficiary created successfully.";
        }
        if (response?.data?.message) {
            message = response.data.message;
        }
        if (!response.success) {
            setIsSaving(false);
            handleApiExceptions(response);
            return;
        }
        alertify("Success", message, "success");
        toggleBeneficiaryModal();
        setIsSaving(false);
        fetchBeneficiaries();
    };

    const updateStatus = async (values, is_active) => {
        setIsListLoading(true);
        const beneficiary = new Beneficiary(values);
        const response = await beneficiary.updateStatus({ active: is_active });
        if (!response.success) {
            setIsListLoading(false);
            handleApiExceptions(response);
            return;
        }
        setIsListLoading(false);
        fetchBeneficiaries();
    };

    const toggleBeneficiaryModal = (beneficiary = {}) => {
        setBeneficiaryModal(!beneficiaryModal);
        setBeneficiary(beneficiary)
    };

    const toggleTransferWizard = (beneficiary = {}) => {
        setActiveBeneficiary(beneficiary);
        setTransferRequestWizard(!transferRequestWizard);
    };

    const handleShowDeactivatedChange = (e) => {
        fetchBeneficiaries(e.target.checked);
    };

    const renderCreateButton = (type = "primary", size = "default") => {
        return (
            <PermissableButton size={size} type={type} onClick={toggleBeneficiaryModal}>
                <Icon type="plus" /> New Beneficiary
            </PermissableButton>
        )
    };
    const renderShowDeactivated = () => {
        return (
            <div>
                <Text5>Show Deactivated:</Text5>
                <Checkbox
                    className="ml-1"
                    size="small"
                    onChange={handleShowDeactivatedChange}
                />
            </div>
        )
    }
    const verifyOTP = (otp) => {
        
        const otp_details = { otp, otp_ref_key: OTPReferenceDetails };
        const beneficiary = new Beneficiary();
        beneficiary.otp_details = otp_details;
        toggleBankOTPModal();
        const saved = { ...saveBeneDetailsRef.current };
        saved.otp_details = otp_details;
        const data = {
            account_number: saved?.account_number,
            ifsc: saved?.account_ifsc,
            beneficiary_name: saved?.account_name,
            id: saved?.uuid,
            upi_handle: saved?.upi_handle || "",
            otp_details: otp_details,
        };
    
        saved?.uuid ? addBeneficiaryOnBank(data) : saveBeneficiary(saved);
    };

    const toggleBankOTPModal = () => {
        setShowOTPModal(!showOTPModal)
    }

    const renderBankOTPModal = async (providerCode = 'SBI', values = {}) => {
        setSaveBeneDetails(values);
        saveBeneDetailsRef.current = values;
        setIsRenderOTPModal(values?.uuid);

        const queryData = {
            type: "beneficiary",
            beneficiary_name: values?.beneficiary_name,
            beneficiary_account_number: values?.account_number,
            beneficiary_ifsc: values?.ifsc,
            provider_code: providerCode,
        };

        try {
            const response = await MerchantService.generate_bank_otp(queryData);

            if (response.success) {
                setShowOTPModal(true);
                setIsBankOTP(true);
                setOTPReferenceDetails(response.otp_ref_key);
            } else {
                handleApiExceptions(response);
            }
        } catch (error) {
            handleApiExceptions({ success: false, status: error?.response?.status || 400 });
        } finally {
            setIsRenderOTPModal(false);
        }
    };


    const addBeneficiaryOnBank = async (values) => {
        setIsSaving(true);
        setBeneOnBankLoaderId(values.id);
        let response = await Beneficiary.add_bene_on_bank(values);
        if (!response.success) {
            setIsSaving(false);
            handleApiExceptions(response);
            setBeneOnBankLoaderId(null);
            return;
        }
        alertify("Success", response?.data?.message, "success");
        // toggleBeneficiaryModal();
        setIsSaving(false);
        setBeneOnBankLoaderId(null);
        fetchBeneficiaries();
    };

    return (
        <EaseDrawer
            className="beneficiaries-drawer-wrapper"
            visible={props.visible}
            hideHeader
            hideFooter
            destroyOnClose
            title={false}
            width={530}
            onOpen={() => fetchBeneficiaries()}
            onClose={() => { setBeneficiaries([]); props.toggleBeneficiariesDrawer() }}
        >
            <div>
                <ContactInfo contact={props.contact} />
                <FullWidthDivider />
                <div className="d-flex justify-content-between" style={{ padding: "15px", paddingBottom: 0 }}>
                    {renderShowDeactivated()}
                    {
                        // beneficiaries.length && !props.contact.is_submerchant?
                        beneficiaries.length ?
                            renderCreateButton("primary", "small") : null
                    }
                </div>
                <Spin spinning={isListLoading}>
                    <BeneficiariesInfo
                        beneficiaries={beneficiaries}
                        updateStatus={updateStatus}
                        toggleTransferWizard={toggleTransferWizard}
                        toggleBeneficiaryModal={toggleBeneficiaryModal}
                        renderBankOTPModal={renderBankOTPModal}
                        renderOTPModal={isRenderOTPModal}
                        showOTPModal={showOTPModal}
                        toggleBankOTPModal={toggleBankOTPModal}
                        isBankOTP={isBankOTP}
                        verifyOTP={verifyOTP}
                        contact={props.contact}
                        current_user={props.current_user}
                        addBeneficiaryOnBank={addBeneficiaryOnBank}
                    // is_submerchant = {!props.contact.is_submerchant}
                        // is_submerchant = {!props.contact.is_submerchant}
                        history={props.history}
                        beneOnBankLoaderId={beneOnBankLoaderId}
                    />
                    {
                        // !beneficiaries.length && !props.contact.is_submerchant ?
                        !beneficiaries.length ?
                            <div className="d-flex justify-content-center">
                                {renderCreateButton("dashed", "default")}
                            </div> : null
                    }
                </Spin>
                <BeneficiaryModal
                    visible={beneficiaryModal}
                    toggleBeneficiaryModal={toggleBeneficiaryModal}
                    contact={props.contact}
                    onSubmit={saveBeneficiary}
                    loading={isSaving}
                    beneficiary={beneficiary}
                    renderBankOTPModal={renderBankOTPModal}
                    renderOTPModal={isRenderOTPModal}
                    showOTPModal={showOTPModal}
                    toggleBankOTPModal={toggleBankOTPModal}
                    isBankOTP={isBankOTP}
                    verifyOTP={verifyOTP}
                />
                <TransferWizard
                    visible={transferRequestWizard}
                    toggleTransferWizard={toggleTransferWizard}
                    selectedContact={props.contact}
                    selectedBeneficiary={activeBeneficiary}
                    addBeneficiaryOnBank={addBeneficiaryOnBank}
                    fetchBeneficiaries={fetchBeneficiaries}
                />
                <OTPModal
                    visible={showOTPModal}
                    onCancel={toggleBankOTPModal}
                    generateOTP={() => renderBankOTPModal('SBI', saveBeneDetailsRef.current)}
                    isBankOTP={isBankOTP}
                    verifyOTP={verifyOTP}
                />
            </div>
        </EaseDrawer>
    );
};

export { BeneficiariesDrawer };